<template>
  <div class="ic-forms">
    <div v-if="!isSent">
      <h2 class="h3">Formularz zgłoszeniowy</h2>

      <div class="ic-form__k-01">
        <FormWrapper :validator="$v.form">

    <IcFormRowWrapper
      id="message"
      rowElement="IcFormRow"
      name="message"
      :aria="$t('aria_required')"
      :label="$t('label_message')"
      :labelWidth="4"
      :controlWidth="8"
    >
      <template slot-scope="{validator}">
        <IcTextarea id="message" v-model="form.message" @input="emitInput(form,validator)"></IcTextarea>
      </template>
    </IcFormRowWrapper>

    <IcFormRowWrapper
      id="files"
      name="files"
      rowElement="IcFormRow"
      :label="$t('label_attachment')"
    >
      <template slot-scope="{validator}">
        <IcInputFile id="files" :maxFiles="3" v-model="form.files"  @input="emitInput(form,validator)" :v="validator"/>
      </template>
    </IcFormRowWrapper>
    <div class="row">
      <div class="col-md-12"><small>{{$t('label_max_filesize')}}</small></div>
    </div>


    <IcFormRowWrapper
      id="firstName"
      rowElement="IcFormRow"
      name="name"
      :aria="$t('aria_required')"
      :label="$t('label_name')"
      :labelWidth="4"
      :controlWidth="8"
    >
      <template slot-scope="{validator}">
        <IcInput id="firstName" v-model="form.name" @input="emitInput(form,validator)"></IcInput>
      </template>
    </IcFormRowWrapper>
   
    <IcFormRowWrapper
      id="email"
      rowElement="IcFormRow"
      name="email"
      :aria="$t('aria_required')"
      :label="$t('label_email')"
      :labelWidth="4"
      :controlWidth="8"
    >
      <template slot-scope="{validator}">
        <IcInput id="email" autocomplete="email"  v-model="form.email" @input="emitInput(form,validator)"></IcInput>
      </template>
    </IcFormRowWrapper>

          <IcFormAgreements v-model="form.agreement" :text="false" :header="false" label="Niniejszym akceptuję i przyjmuję do stosowania postanowienia Regulaminu, co jest równoznaczne z wyrażeniem zgody na przetwarzanie danych osobowych podanych w zgłoszeniu. Administratorem danych osobowych jest PKP Intercity S.A z siedzibą Al. Jerozolimskie 142 A, 02-305 Warszawa. Informacja o przetwarzaniu danych osobowych znajduje się w treści Regulaminu."/>

          <IcFormButtons @click="submit" :sending="isSending" :error="isError" :message="errorMessage" />
        </FormWrapper>
      </div>


    </div>

    <IcFormsSentMikol v-if="isSent" :data="sentData" />
  </div>
</template>
  
<script>
import IcFormsBase from "./Base/FormsBase";
import { get } from "lodash";
import IcFormContactBase from "./Base/ContactBase";
import IcFormContactTopics from "@/components/ic/form/contact/Base/Topics";
import IcFormContactEmail from "@/components/ic/form/contact/Base/Email";
import IcFormContactMessage from "@/components/ic/form/contact/Base/Message";
import IcFormContactFiles from "@/components/ic/form/contact/Base/Files";
import IcFormAgreements from "@/components/ic/form/contact/Base/Agreements";
import IcFormButtons from "@/components/ic/form/contact/Base/Buttons";
import validations from "./Validation/mikol.js";
import Vue from "vue";
import icForm from "@/ic-common/mixins/icForm";
import IcInputEmail from "@/components/ic-common/form/controls/InputEmail";
import IcFormRow from "@/components/ic-common/form/helpers/FormRow.vue";
import IcInput from "@/components/ic-common/form/controls/Input";
import IcTextarea from "@/components/ic-common/form/controls/Textarea";
import IcInputFile from "@/components/ic-common/form/controls/InputFile";
import IcInputFileInput from "@/components/ic-common/form/controls/InputFileInput";
import IcFormsSentMikol from "@/components/ic/form/contact/Base/SentMikol";
import { emitInput } from "./Base/mixins";


const _ = { get };

export default {
  name: "IcFormsMikol",
  extends: IcFormsBase,
  mixins: [icForm],
  validations,
  data() {
    return {
      group: "Contact",
      form: {
        type: "mikol",
        files: [],
        email: "",
        name: "",
        message: "",
        agreement: "",
      },
      formUrl: "/ax26hrxl857-a/components/icforms/connector.php?action=store"

    };
  },

  mounted() {
    let setup = typeof icVSetup !== "undefined" ? icVSetup : {};
    let selected = _.get(setup, "contact.selected");

    this.selected = typeof selected !== "undefined" ? selected : "0";
  },
  methods: {
    emitInput
  },  
  components: {

    IcFormContactEmail,
    IcFormContactMessage,
    IcFormContactFiles,
    IcFormAgreements,
    IcFormButtons,
    IcInputEmail,
    IcInput,
    IcFormRow,
    IcTextarea,
    IcInputFile,
    IcInputFileInput,
    IcFormsSentMikol


  }
};
</script>

<style lang="scss">
</style>
